import axios from 'axios';
import { GlobalApi } from '../../../abs/config/api';

// 用于接口报错发请求，2020年11月23日决定取消发送
function postApiErrorLog(parms: any) {
  const url = window.location.pathname + '/' + window.location.hash;
  let statusCode = parms.data.status_code || parms.data.code;
  const errMsg = parms.data.error_message || parms.data.message;
  const apiUrl = parms.request.responseURL;
  const data = {
    url: url,
    title: document.title,
    api_url: apiUrl,
    api_error: errMsg,
    status_code: statusCode
  };
  axios({
    method: 'post',
    url: GlobalApi.pageLog,
    params: data,
  });
}

export default postApiErrorLog;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/http/request/apiLog.ts